export default {
  props: {
    url: {
      type: String,
      default: "",
    },
    signature: {
      type: String,
      default: "",
    },
  },
  watch: {
    url() {
      this.initPlayer(this.signature);
    },
  },
  data() {
    return {
      id: null,
      player: null,
    };
  },
  mounted() {
    this.initPlayer(this.signature);
  },
};
